import React, { useEffect, useState } from 'react';
import ModalContainer from '../../components/ModalContainer.jsx';
import { Form, Formik } from 'formik';
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import GetField from '../../components/GetField.jsx';
import { initialTouched, initialValues, onSubmit, validationSchema } from './addPropertyFormikCodes.js';
import Alert from '../../utils/Alert.js';
import { getSinglePropertyService } from '../../services/propertiesServices.js';


const AddProperty = () => {
    const [editingProperty, setEditingProperty] = useState(null);
    const [reinitializeValues, setReinitializeValues] = useState(null);

    const { dataLength, setData, itemsCnt } = useOutletContext();

    const navigate = useNavigate();
    const location = useLocation();

    const handleGetEditingProperty = async (propertyId) => {
        try {
            const response = await getSinglePropertyService(propertyId);
            if (response.status === 200) {
                setEditingProperty(response.data);
            }
        } catch (error) {
            Alert(`خطا ${error.response?.status || ""}!`, "در دریافت اطلاعات ویژگی مشکلی رخ داده است!\nلطفاًٌ مجددا تلاش کنید.", "error");
            return navigate(-1);
        }
    }

    useEffect(() => {
        if (location.state) {
            handleGetEditingProperty(location.state.id);
        }
    }, []);

    useEffect(() => {
        if (editingProperty) {
            setReinitializeValues({
                property: editingProperty.property || "",
                slug: editingProperty.slug || "",
                value: editingProperty.value || "",
                type: editingProperty.type || "",
                link: editingProperty.link || ""
            });
        } else {
            setReinitializeValues(null);
        }
    }, [editingProperty]);

    return (
        <ModalContainer
            alwaysOpen={true}
            fullscreen={false}
            title={location.state ?
                `ویرایش ویژگی "${location.state.id}"` :
                "افزودن ویژگی"
            }
        >
            <Formik
                initialValues={reinitializeValues || initialValues}
                initialTouched={reinitializeValues ? initialTouched : {}}
                onSubmit={(values, actions) => onSubmit(values, actions, editingProperty, setData, dataLength, itemsCnt, navigate)}
                validationSchema={validationSchema}
                enableReinitialize
                validateOnMount
            >
                {(formik) => {
                    return (
                        <Form className="flex flex-col 
                            items-center">
                            <div className="mb-5 w-full md:w-4/6 max-w-screen-sm">
                                <GetField
                                    control="input"
                                    name="property"
                                    type="text"
                                    placeholder="property"
                                    label="property"
                                    formik={formik}
                                />
                            </div>
                            <div className="mb-5 w-full md:w-4/6 max-w-screen-sm">
                                <GetField
                                    control="input"
                                    name="slug"
                                    type="text"
                                    placeholder="slug"
                                    label="slug"
                                    formik={formik}
                                />
                            </div>
                            <div className="mb-5 w-full md:w-4/6 max-w-screen-sm">
                                <GetField
                                    control="input"
                                    name="value"
                                    type="text"
                                    placeholder="مقدار ویژگی"
                                    label="مقدار"
                                    formik={formik}
                                />
                            </div>
                            <div className="mb-5 w-full md:w-4/6 max-w-screen-sm">
                                <GetField
                                    control="input"
                                    name="type"
                                    type="text"
                                    placeholder="نوع ویژگی"
                                    label="نوع"
                                    formik={formik}
                                />
                            </div>
                            <div className="mb-5 w-full md:w-4/6 max-w-screen-sm">
                                <GetField
                                    control="input"
                                    name="link"
                                    type="text"
                                    placeholder="آدرس ویژگی"
                                    label="آدرس"
                                    formik={formik}
                                />
                            </div>
                            <div className="w-full text-center mt-4">
                                <GetField
                                    control="submitbutton"
                                    disabledButton={true}
                                    formik={formik}
                                    text={location.state ? "ویرایش ویژگی" : "افزودن ویژگی"}
                                />
                            </div>
                        </Form>
                    );
                }}
            </Formik>
        </ModalContainer>
    );
}

export default AddProperty;
